module.exports = __webpack_public_path__ + "9f0e2228.svg";